//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import datetime from '~/mixins/datetime'
import assets from '~/mixins/assets'

export default {
  mixins: [datetime, assets],
  props: {
    row: Object
  }
}
